import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompanyStateService {
  private verifiedSource = new BehaviorSubject<'0' | '1'>('0');
  verified$ = this.verifiedSource.asObservable();

  setVerified(status: '0' | '1') {
    this.verifiedSource.next(status);
  }
}
